/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_MoreInputs */

const en_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn More`)
};

const fr_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus`)
};

const de_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr erfahren`)
};

const it_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saperne di più`)
};

const ru_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнать больше`)
};

const es_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más información`)
};

const zh_cn2_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多`)
};

const ja_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっと詳しく知る`)
};

const hi_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`और अधिक जानें`)
};

const pt_pt2_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saber mais`)
};

/**
* | output |
* | --- |
* | "Learn More" |
*
* @param {Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const learn_more = /** @type {((inputs?: Learn_MoreInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_MoreInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_learn_more(inputs)
	if (locale === "de") return de_learn_more(inputs)
	if (locale === "it") return it_learn_more(inputs)
	if (locale === "ru") return ru_learn_more(inputs)
	if (locale === "es") return es_learn_more(inputs)
	if (locale === "zh-CN") return zh_cn2_learn_more(inputs)
	if (locale === "ja") return ja_learn_more(inputs)
	if (locale === "hi") return hi_learn_more(inputs)
	if (locale === "pt-PT") return pt_pt2_learn_more(inputs)
	return en_learn_more(inputs)
});